
import React from 'react';
import HeroContainer from './HeroContainer';

const Hero = () => {
  return <HeroContainer />;
};

export default Hero;
